import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import TourTaskBooking from './TourTaskBooking';
import reportWebVitals from './reportWebVitals';

import { LocalizationProvider } from './contexts/LocalizationContext';
import { BusinessProvider } from './contexts/BusinessContext';
import { UIProvider } from './contexts/UIContext';

import 'assets/reset-wp-themes.css';

///////// START Debug Wordpress CSS ///////// Comment out for production
/* import './temp-css/admin-bar.min.css';
import './temp-css/astra-main.min.css';
import './temp-css/sydney-bootstrap.min.css';
import './temp-css/sydney-styles.min.css';
//import './temp-css/dashicons.min.css';
import './temp-css/style.min.css'; */

///////// END Debug Wordpress CSS /////////
const debugWordpressCss = false;
const simulateStickyWpHeader = false;

const rootElement = document.getElementById('tourtask-booking-root') || document.getElementById('root');

if (rootElement === null) {
	throw new Error('Root element not found');
}

// Attempt to read attributes from the root element, fall back to test values
//Default test values

let lang:string = 'es';
let page:string = 'activities';
let businessSlug:string = '';
let businessToken:string = '';
let appRootUrl = '';
let limitedCategoryIds: number[] = [];
let autoDetectCurrency:boolean = true;
let isEmbedded:boolean = false;
let cmsSlug:string|null = null;
let cmsThemeSlug:string|null = null;
let cmsThemeVersion:string|null = null;
let headerName:null|string = null;
let headerType:null|'id'|'class' = null;
let headerIsSticky:boolean = false;
let mobileHeaderName:null|string = null;
let mobileheaderType:null|'id'|'class' = null;
let mobileheaderIsSticky:boolean = false;
let mobileHeaderUntilWidth:number = 0;

let hasExternalSite = false;

const externalSiteAttributes = [
	'data-lang',
	'data-page',
	'data-business-slug',
	'data-business-token',
	'data-auto-detect-currency',
	'data-app-root-url',
	'data-is-embedded',
	'data-limited-category-ids',
	'data-cms-slug',
	'data-cms-theme-slug',
	'data-cms-theme-version',
	'data-header-name',
	'data-header-type',
	'data-header-is-sticky',
	'data-mobile-header-name',
	'data-mobile-header-type',
	'data-mobile-header-is-sticky',
	'data-mobile-header-until-width'
];

externalSiteAttributes.forEach(function(attribute) {
	if (rootElement.hasAttribute(attribute)) {
		hasExternalSite = true
	}
});

if (hasExternalSite) { //Values are fetched from external site
	lang = rootElement.getAttribute('data-lang') || '';
	page = rootElement.getAttribute('data-page') || '';
	businessSlug = rootElement.getAttribute('data-business-slug') || '';
	businessToken = rootElement.getAttribute('data-business-token') || '';
	appRootUrl = rootElement.getAttribute('data-app-root-url') || '';
	autoDetectCurrency = rootElement !== null && rootElement.getAttribute('data-auto-detect-currency') === 'true';
	isEmbedded = (rootElement.getAttribute('data-is-embedded') && rootElement.getAttribute('data-is-embedded') === 'true') ? true : false;
	cmsSlug = rootElement.getAttribute('data-cms-slug') || null;
	cmsThemeSlug = rootElement.getAttribute('data-cms-theme-slug') || null;
	cmsThemeVersion = rootElement.getAttribute('data-cms-theme-version') || null;
	headerName = rootElement.getAttribute('data-header-name') || null;
	headerType = (rootElement.getAttribute('data-header-type') as 'id' | 'class') || null;
	headerIsSticky = rootElement.getAttribute('data-header-is-sticky') === 'true';
	mobileHeaderName = rootElement.getAttribute('data-mobile-header-name') || null;
	mobileheaderType = (rootElement.getAttribute('data-mobile-header-type') as 'id' | 'class') || null;
	mobileheaderIsSticky = rootElement.getAttribute('data-mobile-header-is-sticky') === 'true';
	mobileHeaderUntilWidth = parseInt(rootElement.getAttribute('data-mobile-header-until-width') || '0');

	const limitedCategoryIdsString = rootElement.getAttribute('data-limited-category-ids');

	if (limitedCategoryIdsString) {
		limitedCategoryIds = limitedCategoryIdsString
			.split(',')
			.map(id => parseInt(id.trim(), 10))
			.filter(id => !isNaN(id));
	}
	
	//Remove trailing slash of appRootUrl if present
	if (appRootUrl.slice(-1) === '/') {
		appRootUrl = appRootUrl.slice(0, -1);
	}
}

if (debugWordpressCss || (isEmbedded && cmsSlug === 'wordpress')) {
//   import('assets/reset-wp-themes.css');
}

const root = ReactDOM.createRoot(rootElement);

//Router
root.render(
	<React.StrictMode>
		<>
		{
			simulateStickyWpHeader ? (
				<>
					<div id="custom-header" style={{ height: '100px', /* position: 'sticky',  */backgroundColor: 'lightgrey', top: 0, zIndex: 1000, padding: '20px' }}>
						<h1>Random content</h1>
					</div>
					{/* <div style={{ backgroundColor: 'red', padding: '20px' }}>Some other random stuff</div> */}
				</>
			) : null
		}
			<div
				id="wpadminbar"
				style={{
					display: 'none',
					backgroundColor: '#23282d',
					color: '#fff',
					padding: '10px 0',
					textAlign: 'center',
					fontSize: '14px',
					position: 'fixed',
					width: '100%',
					zIndex: 9999999999999999999,
				}}
			>
				WP Admin bar
			</div>
			{/* <div
				style={{
					padding: '10px',
					backgroundColor: '#f5f5f5',

				}}
			>
				lkasjdf<br />lasd
			</div> */}
			<CssBaseline /> {/* Normalize CSS */}
			<LocalizationProvider>
				<UIProvider
					isEmbedded={isEmbedded}
					cmsSlug={cmsSlug}
					cmsThemeSlug={cmsThemeSlug}
					cmsThemeVersion={cmsThemeVersion}
					headerName={headerName}
					headerType={headerType}
					headerIsSticky={headerIsSticky}
					mobileHeaderName={mobileHeaderName}
					mobileHeaderType={mobileheaderType}
					mobileHeaderIsSticky={mobileheaderIsSticky}
					mobileHeaderUntilWidth={mobileHeaderUntilWidth}
				>
					<BusinessProvider
						lang={lang}
						businessSlug={businessSlug}
						businessToken={businessToken}
						appRootUrl={appRootUrl}
						limitedCategoryIds={limitedCategoryIds}
					>
						<TourTaskBooking page={page} />
					</BusinessProvider>
				</UIProvider>
			</LocalizationProvider>
		</>
	</React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();